export var headImages = {
    items: [
        "/img/masthead/Customers.jpg",
    ],
}